import React from 'react';

import { Text } from '../Text';

export const DT = (props: React.ComponentProps<typeof Text>) => (
  <Text El="dt" color="muted" {...props} />
);
